import { accountStatusMessage } from './accountModeration';

// 浏览器可能将 CORS 拦截、连接失败等情况统一报告为 Network Error，
// 此时不能断定用户断网，也不能读取服务器真实的 HTTP 状态。
export const getRequestFailureMessage = error => {
  const status = error?.response?.status;
  if (status >= 500 && status < 600) return '服务暂时不可用，请稍后重试';
  if (['ECONNABORTED', 'ETIMEDOUT'].includes(error?.code)) return '请求超时，请稍后重试';
  if ((!error?.response || status === 0) && (error?.request || error?.code === 'ERR_NETWORK')) {
    return '暂时无法连接服务，请稍后重试';
  }
  return '';
};

const safeMessage = value => {
  const text = typeof value === 'string' ? value.trim() : '';
  // 代理或 Django 返回的 HTML 错误页不应作为面向用户的提示。
  return /<!doctype\b|<\/?[a-z][^>]*>/i.test(text) ? '' : text;
};

export const getServerErrorMessage = error => {
  const response = error?.response;
  const contentType = response?.headers?.['content-type'] || response?.headers?.get?.('content-type') || '';
  if (/text\/html/i.test(contentType)) return '';
  const data = response?.data;
  if (typeof data === 'string') return safeMessage(data);
  if (!data || typeof data !== 'object') return '';
  const detail = data.detail || data.message || data.non_field_errors
    || Object.entries(data).find(([key]) => !['code', 'status', 'traceback'].includes(key))?.[1];
  return safeMessage(Array.isArray(detail) ? detail[0] : detail);
};

export const getRequestErrorMessage = (error, fallback = '请求失败，请稍后重试') => {
  const failure = getRequestFailureMessage(error);
  if (failure) return failure;
  if (error?.response?.status === 429) {
    const seconds = Number(error.response.headers?.['retry-after']);
    return Number.isFinite(seconds) && seconds > 0 ? `操作太频繁，请 ${Math.ceil(seconds)} 秒后重试` : '操作太频繁，请稍后重试';
  }
  if (error?.response?.status === 401) return accountStatusMessage(error.response.data) || '登录已过期，请重新登录';
  return getServerErrorMessage(error) || fallback;
};
